import { ArrowRight } from "lucide-react";
import { PlayGlyph } from "@/components/Glyphs";
import { PLAY_STORE_URL } from "@/data/site";

const PHRASES = [
  "Warranty_Vault pro is now LIVE on Google Play",
  "Download the app and start tracking your warranties",
  "Never miss a warranty again — get it on Android",
];

const Group = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {PHRASES.concat(PHRASES).map((text, i) => (
      <span key={`${text}-${i}`} className="mx-5 inline-flex items-center gap-2.5 py-2.5 text-sm font-semibold tracking-wide text-gold">
        <PlayGlyph className="h-4 w-4" />
        {text}
        <ArrowRight className="h-4 w-4 opacity-70" />
      </span>
    ))}
  </div>
);

export default function Announcement() {
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="play-announcement"
      aria-label="Warranty_Vault pro is now live on Google Play — open the listing"
      className="group block overflow-hidden border-y border-gold/25 bg-gradient-to-r from-gold/[0.08] via-gold/[0.14] to-gold/[0.08]"
    >
      <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
        <Group />
        <Group hidden />
      </div>
    </a>
  );
}
